<template lang="pug">
    v-list-tile.white--text(style="height: 30px; padding-top: 4px;" :class="colors.secondary")
        v-layout(row  style="height: 100%;")
            v-flex.xs1.text-sm-left CANT
            v-flex.xs6.text-sm-center ITEM
            v-flex.xs2.text-sm-left PRECIO
            v-flex.xs2.text-sm-left DCTO
            v-flex.xs2.text-sm-left SUBTOTAL
</template>
<script>
export default {}
</script>